import { OpenAPI } from 'src/api/generated';
import { request } from 'src/api/generated/core/request';
import {
  type NotificationEndpointCreateBodyParams,
  type NotificationPreferences,
  type NotificationPreferencesUpdateBodyParams,
  type NotificationsInboxListQueryParams,
  type NotificationsInboxListResponse,
  type NotificationsInboxMarkReadBodyParams,
  type NotificationsInboxMarkReadResponse,
  type NotificationsInboxUnreadCountQueryParams,
  type NotificationsInboxUnreadCountResponse,
  type NotificationsEventsListResponse,
  type NotificationsEndpointsListResponse,
} from '../types/notification.types';

export const registerNotificationEndpoint = async (
  body: NotificationEndpointCreateBodyParams
): Promise<void> => {
  await request<unknown>(OpenAPI, {
    method: 'POST',
    url: '/api/notifications/endpoints',
    body,
    mediaType: 'application/json',
  });
};

export const listNotificationInbox = async (
  queryParams: NotificationsInboxListQueryParams
): Promise<NotificationsInboxListResponse> => {
  return await request<NotificationsInboxListResponse>(OpenAPI, {
    method: 'GET',
    url: '/api/notifications/inbox',
    query: queryParams,
  });
};

export const markNotificationInboxRead = async (
  body: NotificationsInboxMarkReadBodyParams
): Promise<NotificationsInboxMarkReadResponse> => {
  return await request<NotificationsInboxMarkReadResponse>(OpenAPI, {
    method: 'POST',
    url: '/api/notifications/inbox/mark-read',
    body,
    mediaType: 'application/json',
  });
};

export const getNotificationUnreadCount = async (
  queryParams: NotificationsInboxUnreadCountQueryParams
): Promise<NotificationsInboxUnreadCountResponse> => {
  return await request<NotificationsInboxUnreadCountResponse>(OpenAPI, {
    method: 'GET',
    url: '/api/notifications/inbox/unread-count',
    query: queryParams,
  });
};

export const getNotificationPreferences =
  async (): Promise<NotificationPreferences> => {
    return await request<NotificationPreferences>(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/preferences',
    });
  };

export const updateNotificationPreferences = async (
  body: NotificationPreferencesUpdateBodyParams
): Promise<NotificationPreferences> => {
  return await request<NotificationPreferences>(OpenAPI, {
    method: 'PUT',
    url: '/api/notifications/preferences',
    body,
    mediaType: 'application/json',
  });
};

export const listNotificationEvents =
  async (): Promise<NotificationsEventsListResponse> => {
    return await request<NotificationsEventsListResponse>(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/events',
    });
  };

export const listNotificationEndpoints =
  async (): Promise<NotificationsEndpointsListResponse> => {
    return await request<NotificationsEndpointsListResponse>(OpenAPI, {
      method: 'GET',
      url: '/api/notifications/endpoints',
    });
  };
